import React, { useState } from "react";
import { Space, Table, Tag } from "antd";
import { ColumnsType } from "antd/lib/table";
import { WbTask } from "../../workbench/types/WbTypes";
import { formatDateTime } from "../utils/workbenchNewSubjectView";
import WorkbenchNewTaskDrawer from "./WorkbenchNewTaskDrawer";

type Props = {
    tasks: WbTask[];
};

const formatTaskReference = (task: WbTask) => {
    if (!task.alphaId) {
        return task.id;
    }

    return typeof task.alphaId === "string"
        ? task.alphaId
        : `${task.alphaId.prefix}-${task.alphaId.index}`;
};

const WorkbenchNewTasksTab: React.FC<Props> = ({ tasks }) => {
    const [selectedTask, setSelectedTask] = useState<WbTask | null>(null);

    const taskColumns: ColumnsType<WbTask> = [
        {
            title: "Task",
            dataIndex: "title",
            key: "title",
            render: (title: string, task: WbTask) => (
                <Space direction="vertical" size={2}>
                    <span className="workbench-new-task-reference">
                        <Tag color="#273C75">{formatTaskReference(task)}</Tag>
                        {title || task.id}
                    </span>
                </Space>
            ),
        },
        {
            title: "Project",
            dataIndex: "projectName",
            key: "project",
            render: (projectName?: string | null) => projectName || "-",
        },
        {
            title: "Assignee",
            dataIndex: "assigneeName",
            key: "assignee",
            render: (assigneeName?: string | null) => assigneeName || "-",
        },
        {
            title: "Owner",
            dataIndex: "ownerName",
            key: "owner",
            render: (ownerName?: string | null) => ownerName || "-",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            render: (status?: string, task?: WbTask) => (
                <Tag color={task?.isDone ? "green" : "blue"}>
                    {task?.isDone ? "Done" : status || "Open"}
                </Tag>
            ),
        },
        {
            title: "Last updated",
            dataIndex: "updatedAt",
            key: "updatedAt",
            render: (updatedAt?: string | null, task?: WbTask) =>
                formatDateTime(updatedAt ?? task?.createdAt),
        },
    ];

    return (
        <>
            <Table<WbTask>
                className="workbench-new-tasks-table"
                columns={taskColumns}
                dataSource={tasks}
                locale={{ emptyText: "No linked tasks" }}
                onRow={(task) => ({
                    onClick: () => setSelectedTask(task),
                })}
                pagination={false}
                rowClassName={(task) =>
                    task.id === selectedTask?.id
                        ? "workbench-new-task-row-selected"
                        : ""
                }
                rowKey="id"
                size="middle"
            />
            <WorkbenchNewTaskDrawer
                onClose={() => setSelectedTask(null)}
                task={selectedTask}
            />
        </>
    );
};

export default WorkbenchNewTasksTab;
